import * as React from "react";
import { forwardRef } from "react";
const SvgBell = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 18 22",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M5.8688 16.2189v1.0438A3.131 3.131 0 0 0 9 20.3939a3.1316 3.1316 0 0 0 3.1313-3.1312v-1.0438M6.9125 3.6939a2.0875 2.0875 0 0 1 4.175 0 7.3061 7.3061 0 0 1 4.175 6.2626v3.1312a4.1758 4.1758 0 0 0 2.0875 3.1312H.65a4.1746 4.1746 0 0 0 2.0875-3.1312V9.9565a7.3062 7.3062 0 0 1 4.175-6.2626Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.2833
}));
const ForwardRef = forwardRef(SvgBell);
export default ForwardRef;
